// extracted by mini-css-extract-plugin
module.exports = {"offerImgContainer":"styles_offerImgContainer__gmcYi","offerImg":"styles_offerImg__3ngOO","sliderDots":"styles_sliderDots__ZNVup"};